import { Injectable } from '@angular/core';
import { ApiRequestService } from 'src/app/shared/api-request.service';
import { AccountConfigurationModel } from 'src/app/models/account-configuration.model';
import { ApiResponseModel } from 'src/app/models/api-response.model';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AccountSettingsService {
  private readonly resourceUrl = 'account-settings';

  constructor(private api: ApiRequestService) {}

  update(
    id: number,
    accountConfig: AccountConfigurationModel
  ): Observable<{}> {
    return this.api.makeRequestObservable(
      'put',
      'v1/' + this.resourceUrl + `/${id}`,
      accountConfig
    );
  }

  find(id: number): Observable<ApiResponseModel<AccountConfigurationModel>> {
    return this.api.makeRequestObservable('get', 'v1/' + this.resourceUrl + `/${id}`);
  }
}
